<template>
    <div class="container overflow-auto">
        <div>
            <b-card-group deck class="container-card">
                <CardInspectionPhases
                    class="mt-2 mr-2 ml-2 mb-0"
                    phaseName="Dados"
                    pathName="data"
                    v-on="$listeners"
                />
                <CardInspectionPhases
                    class="mt-2 mr-2 ml-2 mb-0"
                    phaseName="Questionário"
                    pathName="quiz"
                    v-on="$listeners"
                />
                <CardInspectionPhases
                    class="mt-2 mr-2 ml-2 mb-0"
                    phaseName="Assinatura Vistoriador"
                    pathName="inspectorSignature"
                    v-on="$listeners"
                />
                <CardInspectionPhases
                    class="mt-2 mr-2 ml-2 mb-0"
                    phaseName="Assinatura Cliente"
                    pathName="clientSignature"
                    v-on="$listeners"
                />
                <CardInspectionPhases
                    class="mt-2 mr-2 ml-2 mb-0"
                    phaseName="Fotos"
                    pathName="photosGrid"
                    v-on="$listeners"
                />
            </b-card-group>
        </div>
        <div class="container-buttons">
            <b-button
                class="buttons mt-3 ml-auto"
                variant="success"
                @click="saveInspectionToDatabase"
                id="saveButton"
            >
                <img src="@/assets/quizIcons/ic_sincronizar.png" width="15" />
                Salvar</b-button
            >
        </div>
    </div>
</template>

<script>
import { BButton, BCardGroup } from "bootstrap-vue";
import CardInspectionPhases from "@/components/inspection/CardInspectionPhases.vue";
import Database from "@/controller/database";
import { getDate, getHour } from "@/helper/date";
import Swal from "sweetalert2";

export default {
    components: {
        CardInspectionPhases,
        BButton,
        BCardGroup
    },

    methods: {
        getDate,
        getHour,

        async saveInspectionToDatabase() {
            if (this.$store.getters.allPhasesDone) {
                const database = new Database();
                const inspectionData = {};
                inspectionData.enterprise = this.$store.getters.allInspectionData[0];
                inspectionData.inspectionData = this.$store.getters.allInspectionData[1];
                inspectionData.date = getDate();
                inspectionData.hour = getHour();
                inspectionData.status = "Pendente";
                inspectionData.erroEnviar = null;

                const { date, hour } = inspectionData;
                const { enterprise } = inspectionData.enterprise;
                const { numberPlate } = inspectionData.inspectionData;

                inspectionData.id_vistoria = `${enterprise}_${numberPlate}_${date.replaceAll(
                    "/",
                    "-"
                )}-${hour.replaceAll(":", "-")}`;

                database.createOrOpenDatabase({ inspectionData });

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success m-2",
                        cancelButton: "btn btn-danger m-2",
                    },
                    buttonsStyling: false,
                });

                const isOnline = navigator.onLine;

                if(isOnline) {
                    swalWithBootstrapButtons
                        .fire({
                            title: "Vistoria Concluída!",
                            text: "Deseja transmitir a vistoria?",
                            icon: "success",
                            showCancelButton: true,
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não",
                            showLoaderOnConfirm: true,
                            allowOutsideClick: () => {},
                            preConfirm: () => {
                                this.$router.push({ path: "/transmission" });
                            },
                        })
                        .then((result) => {
                            if (!result.isConfirmed) {
                                Swal.fire({
                                    icon: "warning",
                                    title: "Vistoria Concluída!",
                                    text: "Lembre-se de transmiti-la!",
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "Ok",
                                }).then(() => this.$router.push({ path: "/home" }));
                            }
                        });
                } else {
                    swalWithBootstrapButtons
                        .fire({
                            title: "Vistoria Concluída!",
                            text: "Como o dispositivo não está conectado à internet, a vistoria poderá ser transmitida por meio de um botão na tela inicial assim que o dispositivo estiver online!",
                            icon: "success",
                            confirmButtonText: "OK",
                            showCancelButton: false,
                            allowOutsideClick: false,
                        })
                        .then((result) => {
                            this.$router.push({ path: "/home" });
                        });
                }
                
            } else {
                Swal.fire({
                    title: "Vistoria Incompleta",
                    text: "Termine todas as etapas para salvar a vistoria.",
                    icon: "warning",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Ok",
                });
            }
        },
    },
};
</script>

<style scoped>
.container-card {
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    padding: 2px;
    margin-bottom: 80px;
}

.container-card {
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    padding: 2px;
    margin-bottom: 80px;
}

.container-buttons {
    background: linear-gradient(#cdd7d6, white);
    width: 100%;
    position: fixed;
    bottom: 0;
    padding-left: 7%;
    padding-right: 7%;
    padding-bottom: 10px;
    right: 0;
}

.buttons {
    float: right;
    width: 100px;
}
</style>
